<template>
  <v-card flat rounded class="my-2">
    <v-card-text>
      <h2 class="secondary--text mb-4">Address Information</h2>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="localValue.flatOrRoomNumber"
              label="Flat/Room Number"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="localValue.addressNumber"
              label="Building Number"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localValue.address1"
              label="Address Line 1"
              outlined
              dense
              :rules="[v => !!v || 'Address line 1 is required']"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localValue.address2"
              label="Address Line 2"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localValue.address3"
              label="Town/City"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localValue.address4"
              label="County"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localValue.postcode"
              label="Postcode"
              outlined
              dense
              :rules="postcodeRules"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn text @click="$emit('back')">
        Back
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        :disabled="!canProceed || loading"
        :loading="loading"
        @click="handleNext"
      >
        Next
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ContractorAddressStep",
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      localValue: { ...this.value },
      postcodeRules: [
        v => !!v || "Postcode is required",
        v => /^[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}$/i.test(v) || "Postcode must be valid"
      ]
    };
  },
  computed: {
    canProceed() {
      return this.valid;
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.localValue = { ...newVal };
      },
      deep: true
    },
    localValue: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true
    }
  },
  methods: {
    handleNext() {
      if (this.$refs.form.validate()) {
        this.$emit("next");
      }
    }
  }
};
</script>